var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 아이템 상세 페이지 레이아웃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }